__turbopack_context__.v({
  "customer": "customers-module-scss-module__SrURea__customer",
  "customersButton": "customers-module-scss-module__SrURea__customersButton",
  "customersInner": "customers-module-scss-module__SrURea__customersInner",
  "customersLogos": "customers-module-scss-module__SrURea__customersLogos",
  "exploreButton": "customers-module-scss-module__SrURea__exploreButton",
  "shadow": "customers-module-scss-module__SrURea__shadow",
});
